module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "CT-RECTO"
  }, [_vm._v("“You can still get sunburned on a cloudy day, you know!”")])]), _vm._v(" "), _c('p', {
    staticClass: "COT"
  }, [_vm._v("This is often misquoted by parents and doctors as “You can get a sunburn "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("just as easily")]), _vm._v(" on a cloudy day!” which is dead wrong. Clouds don’t block all the sun’s harmful ultraviolet light, just as they don’t keep all the visible light from getting through, but they do dim it considerably. Even a thin, bright cloud cover will block between 15 and 40 percent of the sun’s UV rays; a more overcast day will block much more.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But it’s easy enough to get a painful burn from even a portion of the sun’s ultraviolet output—cloud cover that blocks fully half the UV is the equivalent of wearing SPF 2 sunscreen, but the American Academy of Dermatology recommends SPF 30 at a minimum. And the cooler weather of cloudy days often fools sunbathers into staying out longer or skipping the sunblock altogether.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In fact, dermatologists say that nervous parents are right about "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("most")]), _vm._v(" of their paranoid-sounding sun warnings. Harmful UVA rays, which can cause skin cancer and premature aging but "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("not")]), _vm._v(" sunburn, are the part of the UV spectrum that isn’t blocked by window glass, so you’re still at risk in a hot car or sunny living room. It takes about an ounce—a full shot glass!—of sunscreen to protect your exposed skin, "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("so most people don’t apply enough, and they also don’t reapply every two hours or after every swim as they should. It’s best to put on sunscreen fifteen minutes or so before heading into the sun, because protection doesn’t begin instantly. And don’t believe that sunburns aren’t harmful if they fade into tans rather than peeling. That’s a function of the skin type you were born with, but "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("any")]), _vm._v(" sunburn is a sign that you’ve damaged your skin, whether you’re fair or dark or tan easily or don’t.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Having just five sunburns in childhood doubles your risk of melanoma later in life. You can get the same effect from just "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("one")]), _vm._v(" childhood sunburn if it’s one of the really bad, lobster-red, blisters-on-your-blisters kind. I wish I had sunnier news for you, but these are not the parental warnings you want to screw around with.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "16",
      "src": "images/f0010-01.jpg",
      "width": "120"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TF"
  }, [_vm._v("TRUE.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f54aa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch06.vue
// module id = 90
// module chunks = 0